import { CheckboxGroup, CheckboxGroupProps, Spacing } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { WorkspaceTypeSpecification } from 'zens-store'

import Specification from './specification'

const styles = StyleSheet.create({
  group: {
    flexWrap: 'wrap',
    marginHorizontal: -Spacing.M,
    maxWidth: undefined,
  },
  specification: {
    marginLeft: Spacing.M,
    marginRight: Spacing.M,
  },
})

interface Props extends Omit<CheckboxGroupProps<WorkspaceTypeSpecification>, 'items'> {}
const Specifications = (props: Props) => {
  const { style, optionStyle, ...otherProps } = props

  const items = Object.values(WorkspaceTypeSpecification).map((value: WorkspaceTypeSpecification) => {
    const title = <Specification value={value} />
    return {
      value,
      title,
    }
  })
  return (
    <CheckboxGroup
      items={items}
      style={[style, styles.group]}
      optionStyle={[optionStyle, styles.specification]}
      {...otherProps}
    />
  )
}

export default Specifications
